import { AntennaId } from '@wwf/sdk';

export const getLinkToAntenna = (antennaId: AntennaId | undefined | null) => {
    if (!antennaId) return '';
    return `/antenna/${antennaId}/show`;
};
